import React, { useEffect } from "react";
import { Modal, Form, Input, Select, Button, Space } from "antd";
import { Candidate, Role } from "../types"; // Import Role

const { Option } = Select;

interface AddCandidateModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAdd: (values: Omit<Candidate, "id" | "appliedDate">) => void;
  roles: Role[]; // --- NEW: Accept roles list ---
}

export const AddCandidateModal: React.FC<AddCandidateModalProps> = ({
  isOpen,
  onClose,
  onAdd,
  roles, // Destructure
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (isOpen) form.resetFields();
  }, [isOpen, form]);

  const handleSubmit = (values: any) => {
    onAdd(values);
    form.resetFields();
  };

  return (
    <Modal
      title="Add New Candidate"
      open={isOpen}
      onCancel={onClose}
      footer={null}
    >
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item name="name" label="Full Name" rules={[{ required: true }]}>
          <Input placeholder="e.g. John Doe" />
        </Form.Item>

        <Form.Item
          name="email"
          label="Email"
          rules={[{ required: true, type: "email" }]}
        >
          <Input placeholder="e.g. john@example.com" />
        </Form.Item>

        <Form.Item
          name="role"
          label="Role Applied For"
          rules={[{ required: true }]}
        >
          <Select placeholder="Select a role">
            {roles.map((r) => (
              <Option key={r.id} value={r.title}>
                {r.title}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item name="status" label="Initial Status" initialValue="Applied">
          <Select>
            <Option value="Applied">Applied</Option>
            <Option value="Screening">Screening</Option>
          </Select>
        </Form.Item>

        <Form.Item style={{ textAlign: "right", marginBottom: 0 }}>
          <Space>
            <Button onClick={onClose}>Cancel</Button>
            <Button type="primary" htmlType="submit">
              Add Candidate
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
};
